import React from "react";
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';

// core components
import GridItem from 'components/Grid/GridItem.js';

import styles from 'views/component/Styles.js';

import SimpleTable from 'views/component/SimpleTable.js';

const useStyles = makeStyles(styles);

export default function Inventory(props) {
    const { factory } = props;
    const classes = useStyles();

    return (<GridItem xs={12} md={4} className={classes.collapsed}>
        <div className={classes.cellTitle}>
            <h4>Material Inventory</h4>
        </div>
        <div className={classes.cellContentAps}>
            <SimpleTable domain="aps" tableName="materialInventory" params={factory} insertAttr={factory} />
        </div>
    </GridItem>);
}